import { render, staticRenderFns } from "./page_header.vue?vue&type=template&id=2feffe0e&scoped=true"
import script from "./page_header.vue?vue&type=script&lang=js"
export * from "./page_header.vue?vue&type=script&lang=js"
import style0 from "./page_header.vue?vue&type=style&index=0&id=2feffe0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feffe0e",
  null
  
)

export default component.exports